export default __webpack_public_path__ + "static/media/6N5A3895.a0bbdea7.jpg";